export default __webpack_public_path__ + "static/after-support-thumbnail-fourth-d4c24c141bab767be6d860ae24182f2c.avif";